
export enum ToastSeverity {
  Error = 'error',
  Success = 'success',
  Warn = 'warn',
  Info = 'info'
}
